import { heading1_parser, heading2_parser, heading3_parser, heading4_parser, heading5_parser } from "./headings";
import { imageParser } from "./image";
import { linkParser } from "./link";
import { bulletListParser, orderedListParser } from "./lists";
import { paragraphParser } from "./paragraph";
import { tableParser } from "./table";
import { inhaltsverzeichnis } from "./inhaltsverzeichnis";
import { viewParser } from "./view";
import { imageRowParser } from "./imageRow";
import { MarkdownGallery } from "@/utils/Markdown/MarkdownGallery";
import { View, Text } from "@/components/Theme";
import { Target } from "@nandorojo/anchor";

export function buildRules(colorScheme) {
    return ({
        gallery: (node, children, parent, styles) => {
            const images = JSON.parse(node.attributes.images ?? "[]");
            return <MarkdownGallery media={images} />;
        },
        spacer: (node) => {
            const h = Number(node.meta?.height ?? node.attributes?.height ?? 0);
            return <View height={h} />;
        },
        anker: (node) => {
            const id = node.attributes.id;
            return <Target style={{height: 0}} name={id} />;
        },
        hardbreak: () => <Text h={5}>{"\n"}</Text>,
        imagerow: (node, children, parent, styles) => imageRowParser(node, children, parent, styles, colorScheme),
        link: (node, children, parent, styles) => linkParser(node, children, parent, styles, colorScheme),
        image: (node, children, parent, styles) => imageParser(node, children, parent, styles, colorScheme),
        heading1:(node, children, parent, styles) => heading1_parser(node, children, parent, styles, colorScheme),
        heading2: (node, children, parent, styles) => heading2_parser(node, children, parent, styles, colorScheme),
        heading3: (node, children, parent, styles) => heading3_parser(node, children, parent, styles, colorScheme),
        heading4: (node, children, parent, styles) => heading4_parser(node, children, parent, styles, colorScheme),
        heading5: (node, children, parent, styles) => heading5_parser(node, children, parent, styles, colorScheme),
        paragraph: (node, children, parent, styles) => paragraphParser(node, children, parent, styles, colorScheme),
        table: (node, children, parent, styles) => tableParser(node, children, parent, styles, colorScheme),
        bullet_list: (node, children, parent, styles) => bulletListParser(node, children, parent, styles, colorScheme),
        ordered_list: (node, children, parent, styles) => orderedListParser(node, children, parent, styles, colorScheme),
        view: (node, children, parent, styles) => viewParser(node, children, parent, styles, colorScheme),
        inhaltsverzeichnis: (node, children, parent, styles) => inhaltsverzeichnis(node, children, parent, styles, colorScheme),

    })
};